export default __webpack_public_path__ + "static/media/GkpD8xwlxlQ-HD.f43d42ae.jpg";